import {
  fromInt2ii0rejb1w62w as fromInt,
  negate13xrbakfwasjy as negate,
  add2suhfggl4zvkk as add,
  subtract2orl8z9upxd9l as subtract,
  dividelr0uqtdj497z as divide,
  multiply2k9eolhnz1bjv as multiply,
  numberToLong2pakxeg38estk as numberToLong,
  convertToInty04h231mmjoh as convertToInt,
  modulooi4g1kq3dmtt as modulo,
  shiftRight2gqph14wydb8s as shiftRight,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { LocalDateTime3vqv9moe7clf4 as LocalDateTime } from './LocalDateTime.mjs';
import {
  Companion_getInstance3rf6ssn2f6rf5 as Companion_getInstance,
  MonthBased16lxw4e6nhntg as MonthBased,
  DayBased28hvf1xjg5r93 as DayBased,
} from './DateTimeUnit.mjs';
import { DatePeriod2y4m7pf19ebgd as DatePeriod } from './DateTimePeriod.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  ArithmeticException18dajwq7kbp38 as ArithmeticException,
} from '../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  toString1pkumu07cwy4m as toString,
  createThis2j2avj17cvnv2 as createThis,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  isLeapYear2i238jn7muq0f as isLeapYear,
  monthLength2df23yfyn71oo as monthLength,
} from './internal/dateCalculations.mjs';
import { get_ONEazvfdh9ju3d4 as get_ONE } from '../../../kotlin-kotlin-stdlib/kotlin/js/internal/boxedLong/boxedLong.mjs';
import {
  Companion_instanceoupd8pza72e0 as Companion_instance,
  get_ISO_DATE_BASIC1k4wiybcckf8 as get_ISO_DATE_BASIC,
  get_ISO_DATE1ah0stqy13618 as get_ISO_DATE,
} from './format/LocalDateFormat.mjs';
import { LocalDateSerializer_getInstance3qg2c8779i3ej as LocalDateSerializer_getInstance } from './serializers/LocalDateSerializers.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  get_number11nqnpf0wxtuc as get_number,
  Monthisypd6pyawk7 as Month,
  firstDayOfYear4msjvujw2l9c as firstDayOfYear,
} from './Month.mjs';
import { DayOfWeek2xlo40o03f5e as DayOfWeek } from './DayOfWeek.mjs';
import { compareTo3ankvs086tmwq as compareTo } from '../../../kotlin-kotlin-stdlib/kotlin/js/compareTo.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
} from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  safeAdd2ojtf0puot5k0 as safeAdd,
  safeMultiply1xb0xo3cufzd3 as safeMultiply,
} from './internal/mathNative.mjs';
import { numberRangeToNumber25vse2rgp6rs8 as numberRangeToNumber } from '../../../kotlin-kotlin-stdlib/kotlin/js/rangeTo.mjs';
import { ClosedRangehokgr73im9z3 as ClosedRange } from '../../../kotlin-kotlin-stdlib/kotlin/ranges/Range.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { contains2c50nlxg7en7o as contains } from '../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { Companion_getInstance5oz1i6ks5glj as Companion_getInstance_0 } from './LocalDateRange.mjs';
import { Comparable198qfk8pnblz0 as Comparable } from '../../../kotlin-kotlin-stdlib/kotlin/Comparable.mjs';
import { DateTimeArithmeticException3b9ehoczpp1e2 as DateTimeArithmeticException } from './Exceptions.mjs';
import { clampToInt3i2uwu7s275hw as clampToInt } from './internal/math.mjs';
import { SerializableWithd2dap36updxd as SerializableWith } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializersJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function plus(_this__u8e3s4, value, unit) {
  return plus_1(_this__u8e3s4, fromInt(value), unit);
}
function atTime(_this__u8e3s4, time) {
  return LocalDateTime().new_kotlinx_datetime_LocalDateTime_zaqrue_k$(_this__u8e3s4, time);
}
function getIsoDateFormat() {
  return Formats_getInstance().get_ISO_18jrwk_k$();
}
function format(_this__u8e3s4, format) {
  return format.format_l1mq08_k$(_this__u8e3s4);
}
function minus(_this__u8e3s4, value, unit) {
  return plus_1(_this__u8e3s4, negate(fromInt(value)), unit);
}
function minus_0(_this__u8e3s4, period) {
  var tmp;
  if (!(period.days_1 === -2147483648) && !(period.get_months_gqmrjw_k$() === -2147483648)) {
    // Inline function 'kotlin.with' call
    var tmp$ret$0 = DatePeriod().new_kotlinx_datetime_DatePeriod_19p8ip_k$(-period.get_years_j1r3xp_k$() | 0, -period.get_months_gqmrjw_k$() | 0, -period.days_1 | 0);
    tmp = plus_0(_this__u8e3s4, tmp$ret$0);
  } else {
    tmp = minus(minus(minus(_this__u8e3s4, period.get_years_j1r3xp_k$(), Companion_getInstance().YEAR_1), period.get_months_gqmrjw_k$(), Companion_getInstance().MONTH_1), period.days_1, Companion_getInstance().DAY_1);
  }
  return tmp;
}
function atTime_0(_this__u8e3s4, hour, minute, second, nanosecond) {
  second = second === VOID ? 0 : second;
  nanosecond = nanosecond === VOID ? 0 : nanosecond;
  return LocalDateTime().new_kotlinx_datetime_LocalDateTime_rd905s_k$(_this__u8e3s4.year_1, _this__u8e3s4.get_month_ivc8d3_k$(), _this__u8e3s4.day_1, hour, minute, second, nanosecond);
}
function validateYearAndDay($this) {
  var containsArg = $this.year_1;
  // Inline function 'kotlin.require' call
  if (!(-999999999 <= containsArg ? containsArg <= 999999999 : false)) {
    var message = 'Invalid date: the year is out of range';
    throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
  }
  var containsArg_0 = $this.day_1;
  // Inline function 'kotlin.require' call
  if (!(1 <= containsArg_0 ? containsArg_0 <= 31 : false)) {
    var message_0 = 'Invalid date: day of month must be a number between 1 and 31, got ' + $this.day_1;
    throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message_0));
  }
  if ($this.day_1 > 28 && $this.day_1 > monthLength($this._month_1, isLeapYear($this.year_1))) {
    if ($this.day_1 === 29) {
      throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$("Invalid date 'February 29' as '" + $this.year_1 + "' is not a leap year");
    } else {
      throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$("Invalid date '" + $this.get_month_ivc8d3_k$().toString() + ' ' + $this.day_1 + "'");
    }
  }
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance_0 = this;
        this.MIN_1 = LocalDate().new_kotlinx_datetime_LocalDate_81790c_k$(-999999999, 1, 1);
        this.MAX_1 = LocalDate().new_kotlinx_datetime_LocalDate_81790c_k$(999999999, 12, 31);
        this.MIN_EPOCH_DAY_1 = -365243219162n;
        this.MAX_EPOCH_DAY_1 = 365241780471n;
      }
      parse_18ba6d_k$(input, format) {
        return format.parse_xovy9i_k$(input);
      }
      parse$default_krgov1_k$(input, format, $super) {
        format = format === VOID ? getIsoDateFormat() : format;
        return $super === VOID ? this.parse_18ba6d_k$(input, format) : $super.parse_18ba6d_k$.call(this, input, format);
      }
      fromEpochDays_a3paq6_k$(epochDays) {
        // Inline function 'kotlin.require' call
        if (!(-365243219162n <= epochDays ? epochDays <= 365241780471n : false)) {
          var message = 'Invalid date: epoch day ' + epochDays.toString() + ' is outside the boundaries of LocalDate';
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
        }
        // Inline function 'kotlin.Long.plus' call
        var zeroDay = add(epochDays, fromInt(719528));
        // Inline function 'kotlin.Long.minus' call
        var this_0 = zeroDay;
        zeroDay = subtract(this_0, fromInt(60));
        var adjust = 0n;
        if (zeroDay < 0n) {
          // Inline function 'kotlin.Long.plus' call
          var this_1 = zeroDay;
          // Inline function 'kotlin.Long.div' call
          var this_2 = add(this_1, fromInt(1));
          // Inline function 'kotlin.Long.minus' call
          var this_3 = divide(this_2, fromInt(146097));
          var adjustCycles = subtract(this_3, fromInt(1));
          // Inline function 'kotlin.Long.times' call
          adjust = multiply(adjustCycles, fromInt(400));
          var tmp = zeroDay;
          // Inline function 'kotlin.Long.times' call
          var this_4 = negate(adjustCycles);
          var tmp$ret$8 = multiply(this_4, fromInt(146097));
          zeroDay = add(tmp, tmp$ret$8);
        }
        // Inline function 'kotlin.Long.plus' call
        var this_5 = multiply(numberToLong(400), zeroDay);
        // Inline function 'kotlin.Long.div' call
        var this_6 = add(this_5, fromInt(591));
        var yearEst = divide(this_6, fromInt(146097));
        var tmp_0 = zeroDay;
        var tmp_1 = multiply(numberToLong(365), yearEst);
        // Inline function 'kotlin.Long.div' call
        var this_7 = yearEst;
        var tmp$ret$11 = divide(this_7, fromInt(4));
        var tmp_2 = add(tmp_1, tmp$ret$11);
        // Inline function 'kotlin.Long.div' call
        var this_8 = yearEst;
        var tmp$ret$12 = divide(this_8, fromInt(100));
        var tmp_3 = subtract(tmp_2, tmp$ret$12);
        // Inline function 'kotlin.Long.div' call
        var this_9 = yearEst;
        var tmp$ret$13 = divide(this_9, fromInt(400));
        var doyEst = subtract(tmp_0, add(tmp_3, tmp$ret$13));
        if (doyEst < 0n) {
          var _unary__edvuaz = yearEst;
          yearEst = subtract(_unary__edvuaz, get_ONE());
          var tmp_4 = zeroDay;
          var tmp_5 = multiply(numberToLong(365), yearEst);
          // Inline function 'kotlin.Long.div' call
          var this_10 = yearEst;
          var tmp$ret$14 = divide(this_10, fromInt(4));
          var tmp_6 = add(tmp_5, tmp$ret$14);
          // Inline function 'kotlin.Long.div' call
          var this_11 = yearEst;
          var tmp$ret$15 = divide(this_11, fromInt(100));
          var tmp_7 = subtract(tmp_6, tmp$ret$15);
          // Inline function 'kotlin.Long.div' call
          var this_12 = yearEst;
          var tmp$ret$16 = divide(this_12, fromInt(400));
          doyEst = subtract(tmp_4, add(tmp_7, tmp$ret$16));
        }
        yearEst = add(yearEst, adjust);
        var marchDoy0 = convertToInt(doyEst);
        var marchMonth0 = (imul(marchDoy0, 5) + 2 | 0) / 153 | 0;
        var month = ((marchMonth0 + 2 | 0) % 12 | 0) + 1 | 0;
        var dom = (marchDoy0 - ((imul(marchMonth0, 306) + 5 | 0) / 10 | 0) | 0) + 1 | 0;
        var tmp0 = yearEst;
        // Inline function 'kotlin.Long.plus' call
        var other = marchMonth0 / 10 | 0;
        yearEst = add(tmp0, fromInt(other));
        return LocalDate().new_kotlinx_datetime_LocalDate_jvtz84_k$(convertToInt(yearEst), month, dom, Unit_instance);
      }
      Format_rqffoz_k$(block) {
        return Companion_instance.build_o3smjo_k$(block);
      }
      serializer_9w0wvi_k$() {
        return LocalDateSerializer_getInstance();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_0;
function Companion_getInstance_1() {
  if (Companion_instance_0 === VOID)
    new (Companion())();
  return Companion_instance_0;
}
var FormatsClass;
function Formats() {
  if (FormatsClass === VOID) {
    class $ {
      constructor() {
        Formats_instance = this;
        this.ISO_BASIC_1 = get_ISO_DATE_BASIC();
      }
      get_ISO_18jrwk_k$() {
        return get_ISO_DATE();
      }
    }
    initMetadataForObject($, 'Formats');
    FormatsClass = $;
  }
  return FormatsClass;
}
var Formats_instance;
function Formats_getInstance() {
  if (Formats_instance === VOID)
    new (Formats())();
  return Formats_instance;
}
function resolvePreviousValid($this, year, month, day) {
  // Inline function 'kotlin.math.min' call
  var b = monthLength(month, isLeapYear(year));
  var newDay = Math.min(day, b);
  return LocalDate().new_kotlinx_datetime_LocalDate_jvtz84_k$(year, month, newDay, Unit_instance);
}
var LocalDateClass;
function LocalDate() {
  if (LocalDateClass === VOID) {
    class $ {
      constructor(year, month, day, unit) {
        return new.target.new_kotlinx_datetime_LocalDate_jvtz84_k$(year, month, day, unit);
      }
      static new_kotlinx_datetime_LocalDate_jvtz84_k$(year, month, day, unit) {
        Companion_getInstance_1();
        var $this = createThis(this);
        $this.year_1 = year;
        $this.day_1 = day;
        $this._month_1 = month;
        return $this;
      }
      static new_kotlinx_datetime_LocalDate_81790c_k$(year, month, day) {
        Companion_getInstance_1();
        var $this = this.new_kotlinx_datetime_LocalDate_jvtz84_k$(year, month, day, Unit_instance);
        var containsArg = $this._month_1;
        // Inline function 'kotlin.require' call
        if (!(1 <= containsArg ? containsArg <= 12 : false)) {
          var message = 'Invalid date: month must be a number between 1 and 12, got ' + $this._month_1;
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
        }
        validateYearAndDay($this);
        return $this;
      }
      static new_kotlinx_datetime_LocalDate_rqj1zf_k$(year, month, day) {
        Companion_getInstance_1();
        var $this = this.new_kotlinx_datetime_LocalDate_jvtz84_k$(year, get_number(month), day, Unit_instance);
        validateYearAndDay($this);
        return $this;
      }
      toEpochDays_tp9eth_k$() {
        var y = fromInt(this.year_1);
        var m = fromInt(this._month_1);
        var total = 0n;
        total = add(total, multiply(numberToLong(365), y));
        if (y >= 0n) {
          var tmp = total;
          // Inline function 'kotlin.Long.plus' call
          // Inline function 'kotlin.Long.div' call
          var this_0 = add(y, fromInt(3));
          var tmp_0 = divide(this_0, fromInt(4));
          // Inline function 'kotlin.Long.plus' call
          // Inline function 'kotlin.Long.div' call
          var this_1 = add(y, fromInt(99));
          var tmp$ret$3 = divide(this_1, fromInt(100));
          var tmp_1 = subtract(tmp_0, tmp$ret$3);
          // Inline function 'kotlin.Long.plus' call
          // Inline function 'kotlin.Long.div' call
          var this_2 = add(y, fromInt(399));
          var tmp$ret$5 = divide(this_2, fromInt(400));
          total = add(tmp, add(tmp_1, tmp$ret$5));
        } else {
          var tmp_2 = total;
          // Inline function 'kotlin.Long.div' call
          var tmp_3 = divide(y, fromInt(-4));
          // Inline function 'kotlin.Long.div' call
          var tmp$ret$7 = divide(y, fromInt(-100));
          var tmp_4 = subtract(tmp_3, tmp$ret$7);
          // Inline function 'kotlin.Long.div' call
          var tmp$ret$8 = divide(y, fromInt(-400));
          total = subtract(tmp_2, add(tmp_4, tmp$ret$8));
        }
        var tmp_5 = total;
        // Inline function 'kotlin.Long.minus' call
        var this_3 = multiply(numberToLong(367), m);
        // Inline function 'kotlin.Long.div' call
        var this_4 = subtract(this_3, fromInt(362));
        var tmp$ret$10 = divide(this_4, fromInt(12));
        total = add(tmp_5, tmp$ret$10);
        var tmp0 = total;
        // Inline function 'kotlin.Long.plus' call
        var other = this.day_1 - 1 | 0;
        total = add(tmp0, fromInt(other));
        if (m > 2n) {
          var _unary__edvuaz = total;
          total = subtract(_unary__edvuaz, get_ONE());
          if (!isLeapYear(this.year_1)) {
            var _unary__edvuaz_0 = total;
            total = subtract(_unary__edvuaz_0, get_ONE());
          }
        }
        // Inline function 'kotlin.Long.minus' call
        var this_5 = total;
        return subtract(this_5, fromInt(719528));
      }
      get_month_ivc8d3_k$() {
        return Month(this._month_1);
      }
      get_dayOfWeek_3kfgci_k$() {
        // Inline function 'kotlin.Long.plus' call
        var this_0 = this.toEpochDays_tp9eth_k$();
        // Inline function 'kotlin.mod' call
        var tmp0 = add(this_0, fromInt(3));
        // Inline function 'kotlin.mod' call
        var other = fromInt(7);
        var r = modulo(tmp0, other);
        var tmp$ret$2 = add(r, other & shiftRight((r ^ other) & (r | negate(r)), 63));
        var dow0 = convertToInt(tmp$ret$2);
        return DayOfWeek(dow0 + 1 | 0);
      }
      get_dayOfYear_3ke6gp_k$() {
        return (firstDayOfYear(this.get_month_ivc8d3_k$(), isLeapYear(this.year_1)) + this.day_1 | 0) - 1 | 0;
      }
      compareTo_e7gwgq_k$(other) {
        var y = compareTo(this.year_1, other.year_1);
        if (!(y === 0)) {
          return y;
        }
        var m = compareTo(this._month_1, other._month_1);
        if (!(m === 0)) {
          return m;
        }
        return compareTo(this.day_1, other.day_1);
      }
      compareTo_hpufkf_k$(other) {
        return this.compareTo_e7gwgq_k$(other instanceof LocalDate() ? other : THROW_CCE());
      }
      plusMonths_8xapro_k$(monthsToAdd) {
        if (monthsToAdd === 0n) {
          return this;
        }
        var tmp0 = multiply(numberToLong(this.year_1), 12n);
        // Inline function 'kotlin.Long.plus' call
        var other = this._month_1 - 1 | 0;
        var monthCount = add(tmp0, fromInt(other));
        var calcMonths = safeAdd(monthCount, monthsToAdd);
        // Inline function 'kotlin.floorDiv' call
        // Inline function 'kotlin.floorDiv' call
        var other_0 = fromInt(12);
        var q = divide(calcMonths, other_0);
        if ((calcMonths ^ other_0) < 0n && !(multiply(q, other_0) === calcMonths)) {
          var _unary__edvuaz = q;
          q = subtract(_unary__edvuaz, get_ONE());
        }
        var newYear = q;
        // Inline function 'kotlin.ranges.contains' call
        var this_0 = numberRangeToNumber(-999999999, 999999999);
        if (!contains(isInterface(this_0, ClosedRange()) ? this_0 : THROW_CCE(), newYear)) {
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$('The result of adding ' + monthsToAdd.toString() + ' months to ' + this.toString() + ' is out of LocalDate range.');
        }
        // Inline function 'kotlin.mod' call
        // Inline function 'kotlin.mod' call
        var other_1 = fromInt(12);
        var r = modulo(calcMonths, other_1);
        var tmp$ret$5 = add(r, other_1 & shiftRight((r ^ other_1) & (r | negate(r)), 63));
        var newMonth = convertToInt(tmp$ret$5) + 1 | 0;
        return resolvePreviousValid(this, convertToInt(newYear), newMonth, this.day_1);
      }
      plusDays_w89bio_k$(daysToAdd) {
        return daysToAdd === 0n ? this : Companion_getInstance_1().fromEpochDays_a3paq6_k$(safeAdd(this.toEpochDays_tp9eth_k$(), daysToAdd));
      }
      rangeTo_fqdtz2_k$(that) {
        return Companion_getInstance_0().fromRangeTo_z28h6r_k$(this, that);
      }
      equals(other) {
        var tmp;
        if (this === other) {
          tmp = true;
        } else {
          var tmp_0;
          if (other instanceof LocalDate()) {
            tmp_0 = this.compareTo_e7gwgq_k$(other) === 0;
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        }
        return tmp;
      }
      hashCode() {
        var yearValue = this.year_1;
        var monthValue = this._month_1;
        var dayValue = this.day_1;
        return yearValue & -2048 ^ (((yearValue << 11) + (monthValue << 6) | 0) + dayValue | 0);
      }
      toString() {
        return format(this, Formats_getInstance().get_ISO_18jrwk_k$());
      }
    }
    initMetadataForClass($, 'LocalDate', VOID, VOID, [Comparable()], VOID, VOID, {0: LocalDateSerializer_getInstance});
    LocalDateClass = $;
  }
  return LocalDateClass;
}
function periodUntil(_this__u8e3s4, other) {
  var months = until(_this__u8e3s4, other, Companion_getInstance().MONTH_1);
  var days = daysUntil(_this__u8e3s4.plusMonths_8xapro_k$(months), other);
  return DatePeriod().new_kotlinx_datetime_DatePeriod_qtu8pv_k$(months, days);
}
function plus_0(_this__u8e3s4, period) {
  // Inline function 'kotlin.with' call
  var tmp;
  try {
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.run' call
    var $this$run = !(period.totalMonths_1 === 0n) ? _this__u8e3s4.plusMonths_8xapro_k$(period.totalMonths_1) : _this__u8e3s4;
    tmp = !(period.days_1 === 0) ? $this$run.plusDays_w89bio_k$(fromInt(period.days_1)) : $this$run;
  } catch ($p) {
    var tmp_0;
    if ($p instanceof ArithmeticException()) {
      var e = $p;
      throw DateTimeArithmeticException().new_kotlinx_datetime_DateTimeArithmeticException_17ykny_k$('Arithmetic overflow when adding a period to a date', e);
    } else {
      if ($p instanceof IllegalArgumentException()) {
        var e_0 = $p;
        throw DateTimeArithmeticException().new_kotlinx_datetime_DateTimeArithmeticException_17ykny_k$('Boundaries of LocalDate exceeded when adding a period', e_0);
      } else {
        throw $p;
      }
    }
  }
  return tmp;
}
function plus_1(_this__u8e3s4, value, unit) {
  var tmp;
  try {
    var tmp_0;
    if (unit instanceof DayBased()) {
      tmp_0 = _this__u8e3s4.plusDays_w89bio_k$(safeMultiply(value, fromInt(unit.days_1)));
    } else {
      if (unit instanceof MonthBased()) {
        tmp_0 = _this__u8e3s4.plusMonths_8xapro_k$(safeMultiply(value, fromInt(unit.months_1)));
      } else {
        noWhenBranchMatchedException();
      }
    }
    tmp = tmp_0;
  } catch ($p) {
    var tmp_1;
    if ($p instanceof ArithmeticException()) {
      var e = $p;
      throw DateTimeArithmeticException().new_kotlinx_datetime_DateTimeArithmeticException_17ykny_k$('Arithmetic overflow when adding a value to a date', e);
    } else {
      if ($p instanceof IllegalArgumentException()) {
        var e_0 = $p;
        throw DateTimeArithmeticException().new_kotlinx_datetime_DateTimeArithmeticException_17ykny_k$('Boundaries of LocalDate exceeded when adding a value', e_0);
      } else {
        throw $p;
      }
    }
  }
  return tmp;
}
function until(_this__u8e3s4, other, unit) {
  var tmp;
  if (unit instanceof MonthBased()) {
    // Inline function 'kotlin.Long.times' call
    var this_0 = get_prolepticMonth(_this__u8e3s4);
    var tmp0 = multiply(this_0, fromInt(32));
    // Inline function 'kotlin.Long.plus' call
    var other_0 = _this__u8e3s4.day_1;
    var packed1 = add(tmp0, fromInt(other_0));
    // Inline function 'kotlin.Long.times' call
    var this_1 = get_prolepticMonth(other);
    var tmp0_0 = multiply(this_1, fromInt(32));
    // Inline function 'kotlin.Long.plus' call
    var other_1 = other.day_1;
    var packed2 = add(tmp0_0, fromInt(other_1));
    // Inline function 'kotlin.Long.div' call
    var this_2 = subtract(packed2, packed1);
    var result = divide(this_2, fromInt(32));
    // Inline function 'kotlin.Long.div' call
    var other_2 = unit.months_1;
    tmp = divide(result, fromInt(other_2));
  } else {
    if (unit instanceof DayBased()) {
      var tmp0_1 = subtract(other.toEpochDays_tp9eth_k$(), _this__u8e3s4.toEpochDays_tp9eth_k$());
      // Inline function 'kotlin.Long.div' call
      var other_3 = unit.days_1;
      tmp = divide(tmp0_1, fromInt(other_3));
    } else {
      noWhenBranchMatchedException();
    }
  }
  return tmp;
}
function daysUntil(_this__u8e3s4, other) {
  return clampToInt(until(_this__u8e3s4, other, Companion_getInstance().DAY_1));
}
function get_prolepticMonth(_this__u8e3s4) {
  var tmp0 = multiply(numberToLong(_this__u8e3s4.year_1), 12n);
  // Inline function 'kotlin.Long.plus' call
  var other = get_number(_this__u8e3s4.get_month_ivc8d3_k$()) - 1 | 0;
  return add(tmp0, fromInt(other));
}
//region block: exports
export {
  Companion_getInstance_1 as Companion_getInstance3h03aipe2gus4,
  LocalDate as LocalDate31mqn6zavbpi8,
  atTime_0 as atTime2v4vw3esgoteo,
  atTime as atTime11qsxhu9qevxe,
  format as format2n4cpzximuj7a,
  minus_0 as minushnjyym3nfk5o,
  periodUntil as periodUntil3upuuey2spoqs,
  plus_0 as plus1oi9f9vif99u2,
  plus as plus1et5dysousgt9,
};
//endregion

//# sourceMappingURL=LocalDate.mjs.map
